// extracted by mini-css-extract-plugin
export default {"avatar":"ZuuJR8o","avatar--clickable":"Ee7g58R"};